import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgOp = function SvgOp(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF0420",
        d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M31.594 86q-8.637 0-14.145-4.041C13.816 79.226 12 75.299 12 70.258c0-1.078.116-2.348.348-3.888.618-3.464 1.507-7.62 2.666-12.51C18.3 40.62 26.803 34 40.485 34c3.71 0 7.072.616 10.009 1.886 2.937 1.193 5.256 3.04 6.956 5.504Q60 45.028 60 50.05q0 1.502-.348 3.81c-.734 4.273-1.584 8.469-2.628 12.51-1.7 6.582-4.599 11.547-8.773 14.819C44.116 84.422 38.551 86 31.594 86m1.044-10.392c2.705 0 4.985-.809 6.879-2.387 1.932-1.578 3.324-4.003 4.135-7.313 1.12-4.542 1.971-8.468 2.55-11.855.194-1 .31-2.04.31-3.117 0-4.388-2.28-6.582-6.88-6.582-2.704 0-5.023.808-6.956 2.386-1.893 1.578-3.246 4.003-4.058 7.313-.888 3.233-1.739 7.16-2.628 11.855-.193.963-.309 1.963-.309 3.04-.039 4.466 2.319 6.66 6.957 6.66M63.456 84c-.526 0-.902-.152-1.202-.495-.226-.38-.301-.799-.226-1.293l9.73-46.424c.075-.532.338-.95.789-1.293A2.05 2.05 0 0 1 73.899 34h18.745c5.222 0 9.392 1.103 12.548 3.273 3.193 2.206 4.808 5.365 4.808 9.512 0 1.18-.15 2.436-.413 3.73-1.165 5.479-3.531 9.512-7.138 12.138-3.531 2.625-8.377 3.92-14.538 3.92h-9.504l-3.23 15.639c-.113.532-.339.95-.79 1.293a2.05 2.05 0 0 1-1.352.495zM88.4 56.717c1.99 0 3.681-.533 5.146-1.636 1.503-1.104 2.48-2.664 2.968-4.719.15-.799.225-1.522.225-2.13 0-1.37-.413-2.436-1.202-3.159-.789-.761-2.179-1.142-4.095-1.142H82.99l-2.667 12.786z"
    })));
};

export { SvgOp as ReactComponent };
//# sourceMappingURL=OP.svg.es.js.map
